function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import Icon from '../icon';
import { size4, size16 } from '../theme/scale';
import { elevationFour } from '../theme/elevations';
import { gray900, gray100, blue100, blue700, red100, red700, teal700, teal100 } from '../theme/colors';
import { fontRegular } from '../theme/fonts';
export const ALERT_VARIANTS = {
  gray: {
    color: gray100,
    background: gray900
  },
  blue: {
    color: blue700,
    background: blue100
  },
  red: {
    color: red700,
    background: red100
  },
  teal: {
    color: teal700,
    background: teal100
  }
};
const AlertWrapper = styled.div`
  padding: ${size16};
  border-radius: ${size4};
  background: ${gray900};
  font-family: ${fontRegular};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${({
  variant
}) => ({
  ...ALERT_VARIANTS[variant]
})};
  box-shadow: ${elevationFour};
`;
const DismissIcon = styled(Icon)`
  fill: currentColor;
`;
const DismissButton = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-self: flex-end;
  color: inherit;
  border: 0;
  padding: 0;
  margin: 0;
  font-family: inherit;
  background: transparent;
  margin-left: ${size16};

  &:hover {
    cursor: pointer;
  }
`;
const Message = styled.p`
  margin: 0;
`;
export const Alert = ({
  message,
  variant = 'gray',
  dismissable = false,
  onDismiss,
  ...props
}) => {
  if (dismissable && (!onDismiss || typeof onDismiss !== 'function')) {
    console.error('Please provide a onDismiss function!');
  }
  return /*#__PURE__*/React.createElement(AlertWrapper, _extends({
    variant: variant
  }, props), /*#__PURE__*/React.createElement(Message, null, message), dismissable && /*#__PURE__*/React.createElement(DismissButton, {
    onClick: onDismiss
  }, /*#__PURE__*/React.createElement(DismissIcon, {
    type: "X",
    size: 20
  })));
};
export default Alert;
//# sourceMappingURL=index.js.map